import styled from "styled-components"
import { Icon } from "../../utils/helpers/getIcon"
import { device } from "../../utils/breakpoints"
import { keyframes } from "styled-components"

export const ServicesContainer = styled.div`
  padding: 32px 0;
  border-top: 4px solid #0000ff;
  border-bottom: 4px solid #0000ff;
  margin: 32px 0;

  @media ${device.desktop} {
    padding: 88px 0;
    margin: 57px 0;
  }
`

export const Title = styled.h2`
  font-size: 28px;
  color: #0000ff;
  letter-spacing: 0;
  line-height: 32px;
  margin-bottom: 25px;

  @media ${device.desktop} {
    font-size: 36px;
    line-height: 42px;
  }
`

export const Accordion = styled.div`
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
  }
`

export const AccordionColumn = styled.div``

export const ServicesDetails = styled.div`
  padding: 14px 0 16px;
  transition: all 0.3s ease-in-out;
  border-top: ${props =>
    props.isOpen ? "1px solid #0000ff" : "1px solid #f0f0f2"};
  svg {
    transition: all 0.3s ease-in-out;
    transform: ${props => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  }
  @media ${device.desktop} {
    padding: 16px 0 16px;
  }
`

export const ServiceIcon = styled(Icon)`
  width: 16px;
  height: 18px;
  margin-top: 3px;
`

export const ServiceSummary = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
  align-items: flex-start;

  p {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.44px;
    line-height: 24px;
    flex: 1;
  }

  @media ${device.desktop} {
    gap: 20px;
    p {
      font-size: 20px;
      letter-spacing: 0.56px;
      line-height: 30px;
    }
  }
`

export const ServiceContent = styled.div`
  margin-top: 8px;
  margin-left: 26px;
  max-height: ${props => (props.isOpen ? "100%" : "0")};
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  p {
    font-size: 14px;
    color: #5a5a5a;
    font-weight: 300;
    letter-spacing: 0.39px;
    line-height: 20px;
  }

  a {
    color: ${props => props.theme.blue} !important;
    font-weight: 500;
    display: inline-block;
    position: relative;
    margin-top: 12px;
    color: ${props => props.theme.primaryColor};
    ::after {
      content: "";
      position: absolute;
      bottom: 3px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${props => props.theme.green};
      opacity: 0;
      transition: 90ms;
    }
    :hover {
      color: #0c0ccd !important;
    }
  }

  @media ${device.desktop} {
    margin-left: 36px;
    p {
      font-size: 16px;
      letter-spacing: 0.44px;
      line-height: 24px;
    }
  }
`
